module.exports = __webpack_public_path__ + "img/aermod-input-file.d68c039f.png";